/* -----------------Child components--------------- */
import { FilterView, useToast } from "@memorang/ui";

import { useDemoExamStore } from "@hooks/useDemoExamStore";
import { useRouter } from "expo-router";
/* -----------------Others--------------- */
import SearchNoResult from "../../../../assets/no-search-results.svg";
type Props = {
	handleClose?: () => void;
	searchIcon?: string;
};
const ExamsFilterRouteView = ({ handleClose, searchIcon }: Props) => {
	const { showToast } = useToast();
	const router = useRouter();

	const { exams, setCurrentExam, currentExam } = useDemoExamStore();
	const examId = currentExam.id;

	const groupedExams = [
		{
			title: "Exams",
			data: exams.map((exam) => ({
				exam,
			})),
		},
	];

	const sectionData = [...(groupedExams || [])].map((group) => ({
		title: group.title,
		data: group.data.map(({ exam }) => ({
			name: exam.name,
			id: exam.id,
		})),
	}));

	const handleAction = (selectedItemId: string) => {
		const newExam = exams.find((exam) => exam.id === selectedItemId);
		const message = `Switched Exam from "${currentExam.name}" to "${newExam?.name}"`;
		setCurrentExam(selectedItemId);

		showToast({
			message,
			duration: 500,
		});
		if (handleClose) {
			handleClose();
		} else {
			router.replace("/account/settings");
		}
	};

	return (
		<>
			<FilterView
				sectionData={sectionData}
				handleAction={handleAction}
				initSelectedItemId={examId}
				actionCta="Switch exam"
				searchIcon={searchIcon}
				emptySearchResultSvg={SearchNoResult}
				currentItemSelectedLabel="Current Exam"
			/>
		</>
	);
};

export default ExamsFilterRouteView;
